import { getData, saveData } from "../../helpers/recentlyViewed";

const data = getData();

const now = Date.now();
// 1 hour
const expiry = 1000 * 60 * 60;

let updated = false;

Promise.all(
  data.map(async (product) => {
    const { savedAt, handle, country, version } = product;
    const isCurrent =
      savedAt &&
      now - savedAt < expiry &&
      version === window.theme.product_card_version;

    if (country === window.theme.country && isCurrent) {
      return product;
    }

    updated = true;

    const root = window.routes.root_url === "/" ? "" : window.routes.root_url;

    try {
      const text = await fetch(
        `${root}/products/${handle}?section_id=pdp-recently-viewed`,
      ).then((res) => res.text());

      const section = new DOMParser().parseFromString(text, "text/html");

      const newData = {
        ...JSON.parse(
          section.querySelector("[data-current-product-data]").innerHTML,
        ),
        savedAt: now,
      };

      return newData;
    } catch (error) {
      return null;
    }
  }),
).then((data) => {
  if (updated) {
    saveData(data.filter((i) => i));
    document.dispatchEvent(new CustomEvent("recently-viewed:refreshed"));
  }
});
